import { VStack, Text, Divider } from "@chakra-ui/react";
import L from "leaflet";
import { GeoJSON, Popup } from "react-leaflet";
import { GeoJsonObject, FeatureCollection } from "geojson";
import essentialServicePin from "_assets/imgs/mapa/markers/map-icon-orange.png";
import { useState } from "react";
import { PostOuvidoriaEssencial } from "store/modules/ouvidoria/pontosessenciais/actions/getEssentialServicesGeojson";

const essentialServiceIcon = new L.Icon({
  iconUrl: essentialServicePin,
  iconSize: [30.48, 50],
  iconAnchor: [15.24, 50],
  shadowSize: [61, 61]
});

type PopupEssencial = PostOuvidoriaEssencial & { lat: number; lng: number };

export function EssencialGeojson({
  featureCollection
}: {
  featureCollection: FeatureCollection<GeoJSON.Point, PostOuvidoriaEssencial>;
}) {
  const [popup, setPopup] = useState<PopupEssencial | null>(null);

  return (
    <>
      <GeoJSON
        key={JSON.stringify(featureCollection)}
        data={featureCollection as GeoJsonObject}
        pointToLayer={(feature, latlng) => {
          return L.marker(latlng, { icon: essentialServiceIcon });
        }}
        eventHandlers={{
          click: (f) => {
            setPopup({
              ...f.layer.feature.properties,
              lat: f.latlng.lat,
              lng: f.latlng.lng
            });
            console.log({
              ...f.layer.feature.properties,
              lat: f.latlng.lat,
              lng: f.latlng.lng
            });
          }
        }}
      />
      {popup && (
        <Popup
          offset={[0, -40]}
          position={[popup.lat, popup.lng]}
          onClose={() => setPopup(null)}
        >
          <VStack p={2} justify="flex-start" align="flex-start">
            <Text fontSize="xl" fontWeight="semibold">
              Ponto essencial
            </Text>
            <Text fontSize="md" fontWeight="medium">
              {popup.titulo}
            </Text>
            <Divider my={1} />
            <Text fontSize="sm">
              Endereço: {popup.endereco.logradouro}, {popup.endereco.bairro} -{" "}
              {popup.endereco.municipio}
            </Text>
          </VStack>
        </Popup>
      )}
    </>
  );
}
